import { useEffect, useState } from "react";
import { api, fmtINR } from "@/lib/api";
import { PageHeader } from "@/components/common";
import { Card } from "@/components/ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { QUARTERS } from "@/lib/constants";
import {
  BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Cell,
} from "recharts";

export default function Forecast() {
  const [data, setData] = useState(null);
  const [quarter, setQuarter] = useState("");
  useEffect(() => {
    api.get("/forecast", { params: { quarter: quarter || undefined } }).then((r) => setData(r.data));
  }, [quarter]);

  if (!data) return <div className="p-6 text-slate-500">Loading…</div>;

  return (
    <div data-testid="forecast-page">
      <PageHeader title="Sales Forecast" description="Pipeline outlook by quarter, stage and owner." action={
        <Select value={quarter || "all"} onValueChange={(v) => setQuarter(v === "all" ? "" : v)}>
          <SelectTrigger className="w-32"><SelectValue placeholder="Quarter" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Quarters</SelectItem>
            {QUARTERS.map((q) => <SelectItem key={q} value={q}>{q}</SelectItem>)}
          </SelectContent>
        </Select>
      } />

      <div className="grid lg:grid-cols-2 gap-6">
        <Card className="p-5">
          <h3 className="font-semibold mb-4">By Stage</h3>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={data.by_stage}>
              <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
              <XAxis dataKey="stage" tick={{ fontSize: 10 }} interval={0} angle={-25} textAnchor="end" height={70} />
              <YAxis tick={{ fontSize: 11 }} />
              <Tooltip formatter={(v) => fmtINR(v)} />
              <Bar dataKey="value" fill="#fd7e14" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </Card>
        <Card className="p-5">
          <h3 className="font-semibold mb-4">By Quarter</h3>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={data.by_quarter}>
              <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
              <XAxis dataKey="_id" tick={{ fontSize: 11 }} />
              <YAxis tick={{ fontSize: 11 }} />
              <Tooltip formatter={(v) => fmtINR(v)} />
              <Bar dataKey="value" fill="#16A34A" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </Card>
      </div>

      <Card className="p-5 mt-6">
        <h3 className="font-semibold mb-4">Top Owners</h3>
        <Table>
          <TableHeader><TableRow><TableHead>Owner</TableHead><TableHead>Count</TableHead><TableHead className="text-right">Value</TableHead></TableRow></TableHeader>
          <TableBody>
            {(data.by_owner || []).map((o) => (
              <TableRow key={o.owner_id}>
                <TableCell className="font-medium">{o.owner_name}</TableCell>
                <TableCell>{o.count}</TableCell>
                <TableCell className="text-right font-semibold">{fmtINR(o.value)}</TableCell>
              </TableRow>
            ))}
            {(data.by_owner || []).length === 0 && <TableRow><TableCell colSpan={3} className="text-center text-slate-500 py-6">No data</TableCell></TableRow>}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
